"use client";

import { getApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import React, { useEffect } from "react";
import { toast } from "sonner";

import ExchangeImage from "@/components/global/exchange-swticher/exchangeIcon";
import { firebaseCloudMessaging } from "@/lib/firebaseMessaging";

import { useAuth } from "./auth/AuthContext";
import {
  NotificationType,
  setNotifications,
  updateNotificationBadge,
} from "../redux/notifications.slice";
import { store } from "../redux/store";

function PushNotificationLayout({ children }: any) {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.uid && "serviceWorker" in navigator) setToken();
    async function setToken() {
      try {
        await firebaseCloudMessaging.init();
        onMessaging();
      } catch (error) {
        if (process.env.NODE_ENV === "development") console.log(error);
      }
    }
  }, [user?.uid]);

  const onMessaging = () => {
    onMessage(getMessaging(getApp()), async ({ data }: any) => {
      const currentNotifications: NotificationType[] = [
        ...store?.getState()?.notifications?.notifications,
      ];
      currentNotifications.unshift(data);
      store.dispatch(setNotifications(currentNotifications));
      store.dispatch(updateNotificationBadge(true));
      toast.custom(
        (id) => (
          <div
            className="flex flex-1 gap-4 p-4 rounded-sm bg-[#00416A] text-white"
            key={id}
          >
            {data?.provider_id && (
              <ExchangeImage
                providerId={parseInt(
                  data?.provider_id ?? data?.icon?.provider_id ?? "",
                )}
                width={24}
                height={24}
              />
            )}
            <div className="flex flex-col gap-2">
              <h2 className="font-bold text-base">{data?.title}</h2>
              <h4 className="font-medium text-sm">{data?.body}</h4>
            </div>
          </div>
        ),
        {
          duration: 30000,
        },
      );
    });
  };

  return <>{children}</>;
}

export default PushNotificationLayout;
